$(document).ready(function() {
  $('.ProductForm__Option.SubscribeSelect input[type="radio"]').change(function() {
    if($(this).val() == 'subscribe') {
      $(this).parents('form').find('.frequencySelect_wrapper').show();
      $(this).parents('form').find('span.VariantData_Copy.Subscribe.VariantData_Price.Text--subdued').show();
      $(this).parents('form').find('span.VariantData_Copy.Single.VariantData_Price.Text--subdued').hide();
    } else {
      $(this).parents('form').find('.frequencySelect_wrapper').hide();
      $(this).parents('form').find('span.VariantData_Copy.Subscribe.VariantData_Price.Text--subdued').hide();
      $(this).parents('form').find('span.VariantData_Copy.Single.VariantData_Price.Text--subdued').show();
    }
  });

  $('.ProductForm__Variants label.SizeSwatch').click(function() {
    $(this).parents('form').find('.SubscribeSelect label.onetime span.ProductSubscribe__Price.Price--highlight.Price.Text--subdued.u-h4').text($(this).data('regular_price'));
    $(this).parents('form').find('.SubscribeSelect label.onetime span.ProductSubscribe__Price.Price--compareAt.Price.Text--subdued.u-h4').text($(this).data('comp_price'));
    $(this).parents('form').find('.SubscribeSelect label.subscribe span.ProductSubscribe__Price.Price--highlight.Price.Text--subdued.u-h4').text($(this).data('sub_regular_price'));
    $(this).parents('form').find('.SubscribeSelect label.subscribe span.ProductSubscribe__Price.Price--compareAt.Price.Text--subdued.u-h4').text($(this).data('sub_disc'));
  });

  $('.landing-page__AddToCart').click(function(e) {
    e.preventDefault();
    let productId = $(this).data('prodid');
    let sellingPlan = '';
    let variantid = $(this).parent(`#product_form_${productId}`).find('.ProductForm__Variants .HorizontalList__Item input[type="radio"]:checked').data('variant_id');
    let buyOption = $(this).parent(`#product_form_${productId}`).find('.SubscribeSelect input[type="radio"]:checked').val();

    if(buyOption == 'subscribe') {
      sellingPlan = parseInt($(this).parents(`#product_form_${productId}`).find('.ProductForm__Option.FrequencySelect input[type="radio"]:checked').val());
    }

    let data = {
      id: variantid,
      quantity: 1,
      selling_plan: sellingPlan
    };

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function(response) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        document.dispatchEvent(new CustomEvent("product:added", { detail: { product: response} }));
      }
    });
  });
});